module.exports = __webpack_public_path__ + "static/media/magic-wand-light.2f69b0ae.svg";